import {
  getMessageTimestampMs,
  normalizeMessageTimestampValue,
} from './normalizeMessageTimestamp';

/**
 * Returns a stable day key for grouping messages by calendar date.
 */
export function getMessageDateKey(message) {
  const ms = getMessageTimestampMs(message);
  if (ms == null) return null;

  const date = new Date(ms);
  if (Number.isNaN(date.getTime())) return null;

  return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
}

/**
 * Formats a message timestamp as an uppercase date separator label.
 */
export function formatMessageDateSeparator(dateValue) {
  const ms =
    typeof dateValue === 'object' && dateValue !== null && !Array.isArray(dateValue)
      ? getMessageTimestampMs(dateValue)
      : normalizeMessageTimestampValue(dateValue);

  if (ms == null) return '';

  try {
    return new Date(ms)
      .toLocaleDateString(undefined, {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      })
      .toUpperCase();
  } catch {
    return '';
  }
}
